import { AvnuSwapTransactionHistoryItem } from '../../interfaces/AvnuSwapTransactionHistoryItem';
import { walletAddressAtom } from '../wallet';
import storage from '../../storage';
import { createAsyncAtom } from '../../lib/state';

const nostraSwapTransactionHistoryAtom = createAsyncAtom<AvnuSwapTransactionHistoryItem[]>(
  async get => {
    const walletAddress = await get(walletAddressAtom);
    if (!walletAddress) {
      return null;
    }

    try {
      const data = await storage.getNostraSwapTransactionHistory(walletAddress);
      if (!data) {
        return null;
      }

      return data.map(doc => {
        return {
          hash: doc.id,
          account: doc.walletAddress,
          buyAddress: doc.tokenAAmountOut === '0' ? doc.tokenBAddress : doc.tokenAAddress,
          buyAmount: doc.tokenAAmountOut === '0' ? doc.tokenBAmountOut : doc.tokenAAmountOut,
          sellAddress: doc.tokenAAmountIn === '0' ? doc.tokenBAddress : doc.tokenAAddress,
          sellAmount: doc.tokenAAmountIn === '0' ? doc.tokenBAmountIn : doc.tokenAAmountIn,
          timestamp: doc.timestamp * 1000,
        };
      });
    } catch (e) {
      console.error('nostraSwapTransactionHistory - Failed to get nostra swap transaction history', e);
      return null;
    }
  },
  undefined,
  ['user-refresh'],
);
export default nostraSwapTransactionHistoryAtom;
